import api from "../services/BackendServices";
import { parseJwt } from "../utils/parseJwt";
const ecommerceModel = {
  state: {
    cart: {},
    isLoading: false,
    message: "",
    response: null,
    cartVersion: 0,
    pausedCount: 0,
  },
  reducers: {
    setCart(state, cart) {
      return Object.assign({}, { ...state, cart: cart });
    },
    setMessage(state, msj) {
      return Object.assign({}, { ...state, message: msj });
    },
    resetCart(state) {
      return Object.assign({}, { ...state, cart: {} });
    },
    setLoading(state, isLoading) {
      return Object.assign({}, { ...state, isLoading: isLoading });
    },
    setResponse(state, response) {
      return Object.assign({}, { ...state, response: response });
    },
    clearResponse(state) {
      return Object.assign({}, { ...state, response: null });
    },
    updateCartVersion(state, payload) {
      return Object.assign({}, { ...state, cartVersion: state.cartVersion++ });
    },
    setPausedCount(state, pausedCount) {
      return Object.assign({}, { ...state, pausedCount: pausedCount });
    },
  },
  effects: {
    async updateCart(payload, state) {
      if (payload) {
        this.setLoading(true);
        const { client, sucursal } = state.sso;
        const otherModelState = parseJwt(state.sso.token); // ssoModel.state.token(state.ssoModel);
        try {
          const response = await api.EcommerceServices.getCurrentOrder(
            payload,
            client.id.id,
            sucursal.id.clBranchOffice
          );
          this.setCart(response.data);
          this.updateCartVersion();
          this.setLoading(false);
        } catch (e) {
          this.setLoading(false);
        }
        return true;
      } else {
        alert("Ha ocurrido un problema. Cierre sesión y vuelva a ingresar.");
      }
    },
    // Cantidad de pedidos pausados del cliente, para la alerta del header.
    // Se refresca al cambiar de cliente/sucursal y cada vez que se pausa,
    // reanuda o anula un pedido.
    async updatePausedCount(payload, state) {
      const { client } = state.sso;
      const clientId = client?.id?.id;

      if (!clientId) return;

      try {
        const response = await api.EcommerceServices.getPausedOrdersCount(
          clientId
        );
        this.setPausedCount(response.data?.count ?? 0);
      } catch (e) {
        // La alerta es informativa: si falla el conteo no se interrumpe al usuario.
        this.setPausedCount(0);
      }
    },
    async addToCart({ publicKey, products, ...rest }, state) {
      if (publicKey) {
        this.setLoading(true);
        const { client, sucursal } = state.sso;
        this.setMessage("");
        try {
          const response = await api.EcommerceServices.addToCart(
            publicKey,
            client.id.id,
            sucursal.id.clBranchOffice,
            products,
            {
              observacion: rest?.observation,
              transporte: rest?.transport,
              deliveredBy : rest?.deliveredBy,
              desiredDate: rest?.desiredDate,
              deliveryMode: rest?.deliveryMode,
              revisionComercial: rest?.revisionComercial,
              updateProduct: rest.updateProduct ? true : false
              
            }
          );
          if (response.data.validations.length > 0) {
            alert(
              response.data.validations.map((message) => message).join("\n")
            );
          }

          this.setResponse(response);
          this.updateCart(publicKey);
          this.setLoading(false);
        } catch (e) {
          alert(e?.response?.data?.message ? e?.response?.data?.message : e);
          this.setLoading(false);
        }
        return true;
      } else {
        alert("Ha ocurrido un problema. Cierre sesión y vuelva a ingresar.");
      }
    },
    async removeFromCart({ publicKey, id }, state) {
      if (publicKey) {
        this.setLoading(true);
        this.setMessage("");
        try {
          const response = await api.EcommerceServices.removeFromCart(
            publicKey,
            id
          );
          this.setResponse(response);
          this.updateCart(publicKey);
          this.setLoading(false);
        } catch (e) {
          this.setLoading(false);
        }
        return true;
      } else {
        alert("Ha ocurrido un problema. Cierre sesión y vuelva a ingresar.");
      }
    },
    async cleanCart(publicKey, state) {
      if (publicKey) {
        this.setLoading(true);
        this.setMessage("");
        try {
          const response = await api.EcommerceServices.cleanCart(
            publicKey,
            state.ecommerce.cart.order.number
          );
          this.setResponse(response);
          this.updateCart(publicKey);
          this.setLoading(false);
        } catch (e) {
          this.setLoading(false);
        }
        return true;
      } else {
        alert("Ha ocurrido un problema. Cierre sesión y vuelva a ingresar.");
      }
    },
    async sendCart(data, state) {
      if (data.publicKey) {
        this.setLoading(true);
        const { client, sucursal } = state.sso;
        const { cart } = state.ecommerce;
        this.setMessage("");
        try {
          const response = await api.EcommerceServices.sendCart({
            orderId: cart.order.number,
            clientId: client.id.id,
            deliveredBy: data.deliveredBy,
            desiredDate: data.desiredDate,
            revisionComercial: data.revisionComercial,
            ...data,
          });

          // ELIMINAMOS EL alert("El pedido fue enviado") DE AQUÍ
          // porque el componente Footer ya tiene su propio alert de éxito.

          this.setResponse(response);
          this.updateCart(data.publicKey);
          this.setLoading(false);

          return response; // IMPORTANTE: retornar para que el Footer sepa que terminó bien
        } catch (e) {
          this.setLoading(false);
          // IMPORTANTE: Lanzar el error para que el 'catch' del Footer lo atrape
          throw e;
        }
      } else {
        alert("Ha ocurrido un problema. Cierre sesión y vuelva a ingresar.");
      }
    },
    async pauseCart(data, state) {
      if (data.publicKey) {
        this.setLoading(true);
        const { cart } = state.ecommerce;
        this.setMessage("");
        try {
          const response = await api.EcommerceServices.pauseCart({
            orderId: cart.order.number,
            notifySeller: data.notifySeller,
            reason: data.reason,
          });
          // El backend informa si pudo avisarle al vendedor: el pausado se
          // ejecuta igual, así que el mensaje cambia pero no es un error.
          alert(response?.data?.message || "El pedido fue pausado exitosamente");
          this.setResponse(response);
          this.updateCart(data.publicKey);
          this.updatePausedCount();
          this.setLoading(false);
        } catch (e) {
          alert(
            e?.response?.data?.message
              ? e?.response?.data?.message
              : "Error al pausar el pedido"
          );
          this.setLoading(false);
          // Se propaga para que el modal de pausado no se cierre si falló.
          throw e;
        }
      } else {
        alert("Ha ocurrido un problema. Cierre sesión y vuelva a ingresar.");
      }
    },
    async resumeCart(data, state) {
      console.log(JSON.stringify(data, null, 2));
      if (data.publicKey) {
        this.setLoading(true);
        this.setMessage("");
        try {
          const response = await api.EcommerceServices.resumeCart({
            orderId: data.orderId,
            sucursalId: data.sucursalId,
          });
          alert("El pedido fue reanudado exitosamente");
          this.setResponse(response);
          this.updateCart(data.publicKey);
          this.updatePausedCount();
          this.setLoading(false);
        } catch (e) {
          alert(
            e?.response?.data?.message
              ? e?.response?.data?.message
              : "Error al reanudar el pedido"
          );
          this.setLoading(false);
        }
      } else {
        alert("Ha ocurrido un problema. Cierre sesión y vuelva a ingresar.");
      }
    },
    // Anula un pedido. Solo el backend decide si el estado lo permite.
    // Se refresca el carrito porque el pedido anulado puede ser el que el
    // usuario tiene abierto en pantalla.
    async cancelOrder(data, state) {
      if (data.publicKey) {
        this.setLoading(true);
        this.setMessage("");
        try {
          const response = await api.EcommerceServices.cancelOrder({
            orderId: data.orderId,
            reason: data.reason,
          });
          alert("El pedido fue anulado exitosamente");
          this.setResponse(response);
          this.updateCart(data.publicKey);
          this.updatePausedCount();
          this.setLoading(false);
          return response;
        } catch (e) {
          alert(
            e?.response?.data?.message
              ? e?.response?.data?.message
              : "Error al anular el pedido"
          );
          this.setLoading(false);
          throw e;
        }
      } else {
        alert("Ha ocurrido un problema. Cierre sesión y vuelva a ingresar.");
      }
    },
  },
};
export default ecommerceModel;
